export const formatPrice = (price: number) => {
  if (price <= 0) {
    return 'Grátis';
  }

  return price.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    style: 'currency',
    currency: 'BRL',
  });
};
